import * as types from "./types";
import axios from "axios";

export default {
  [types.INITIALIZE_PROMOTION]: (
    { commit },
    { consultantId, targetRoleId, promotionReasonId }
  ) => {
    return axios
      .get(`api/consultants/${consultantId}/promotion`, {
        params: { targetRoleId, promotionReasonId },
      })
      .then((resp) => {
        commit(types.SET_INITIAL_DATA, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  [types.SAVE_CHECKLIST_ITEM]: ({ dispatch, state }, payload) => {
    const consultantId = state.status.consultant_id;

    return axios
      .put(`/api/consultants/${consultantId}/promotion_step`, payload)
      .then(() => {
        return dispatch(types.INITIALIZE_PROMOTION, {
          consultantId,
          targetRoleId: state.status.target_role_id,
        });
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};
